module.exports = __webpack_public_path__ + "static/media/doubler.186dba2f.JPG";